import React, { useEffect, useState } from 'react';
import { api } from '../api';

let cache = null; let cacheAt = 0;
function loadRanges() {
  if (!cache || Date.now() - cacheAt > 60000) { cacheAt = Date.now(); cache = api.get('/shifts/ranges').catch(() => []); }
  return cache;
}

export default function ShiftTag({ billId }) {
  const [shift, setShift] = useState(undefined);
  useEffect(() => {
    let alive = true;
    loadRanges().then((rows) => {
      const id = Number(billId);
      const s = (rows || []).find((r) => id > Number(r.start_bill_id) && (r.end_bill_id == null || id <= Number(r.end_bill_id)));
      if (alive) setShift(s || null);
    });
    return () => { alive = false; };
  }, [billId]);
  if (shift === undefined) return null;
  const name = shift ? shift.name || `Shift #${shift.id}` : 'No shift';
  const night = /night|even/i.test(name);
  const style = !shift ? { bg: '#fee2e2', fg: '#b91c1c', icon: '⚠️' } : night ? { bg: '#ede9fe', fg: '#5b21b6', icon: '🌙' } : { bg: '#fef3c7', fg: '#92400e', icon: '🌅' };
  return (
    <span title={shift ? `Shift #${shift.id} · ${shift.business_date || ''}` : 'Billed while no shift was open'}
      style={{ display: 'inline-block', marginLeft: 8, padding: '2px 8px', borderRadius: 999, fontSize: 11.5, fontWeight: 700, background: style.bg, color: style.fg, whiteSpace: 'nowrap', verticalAlign: 'middle' }}>
      {style.icon} {name}
    </span>
  );
}
